import React from 'react';
import { UploadItem } from '@Types';
import { FileRow } from './FileRow';
import styles from './FileList.module.scss';

interface FileListProps {
  pendingUploads: Array<{ tempId: string; filename: string }>;
  getProgressById: (id: string) => number;
  onDeleteFile: (id: string | number) => void;
  failedUploads?: Array<{ tempId: string; filename: string; error: string }>;
  completedUploads?: Array<UploadItem>;
  onRetryUpload?: (id: string) => void;
}

export const FileList = ({
  pendingUploads,
  getProgressById,
  onDeleteFile,
  failedUploads = [],
  completedUploads = [],
  onRetryUpload,
}: FileListProps) => {
  // If there are no pending, failed, or completed uploads, don't render the component.
  if (!pendingUploads.length && !failedUploads.length && !completedUploads.length) {
    return null;
  }

  return (
    <div className={styles.filesContainer}>
      <div className={styles.fileListWrapper}>
        {pendingUploads.map((item) => (
          <FileRow
            key={item.tempId}
            id={item.tempId}
            filename={item.filename}
            progress={getProgressById(item.tempId)}
            isUploading={true}
            onDelete={onDeleteFile}
          />
        ))}

        {failedUploads.map((item) => (
          <FileRow
            key={item.tempId}
            id={item.tempId}
            filename={item.filename}
            isUploading={false}
            isFailed={true}
            error={item.error}
            onDelete={onDeleteFile}
            onRetry={onRetryUpload}
          />
        ))}

        {completedUploads.map((doc) => (
          <FileRow
            key={doc.id}
            id={doc.id}
            filename={doc.filename}
            url={doc.url}
            isUploading={false}
            onDelete={onDeleteFile}
          />
        ))}
      </div>
    </div>
  );
};
